/**
 * @generated SignedSource<<fc448e45b332b45706991ec7bc30db8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type getPropertyTypeCustomAttributesQuery$variables = {};
export type getPropertyTypeCustomAttributesQuery$data = {
  readonly sys_property_type_custom_attributes: ReadonlyArray<{
    readonly custom_attributes: any;
    readonly property_type_id: number;
  }>;
};
export type getPropertyTypeCustomAttributesQuery = {
  response: getPropertyTypeCustomAttributesQuery$data;
  variables: getPropertyTypeCustomAttributesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "sys_property_type_custom_attributes",
    "kind": "LinkedField",
    "name": "sys_property_type_custom_attributes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "property_type_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "custom_attributes",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "getPropertyTypeCustomAttributesQuery",
    "selections": (v0/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "getPropertyTypeCustomAttributesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "6ce40a96f9b69d3865bd0ee816b74700",
    "id": null,
    "metadata": {},
    "name": "getPropertyTypeCustomAttributesQuery",
    "operationKind": "query",
    "text": "query getPropertyTypeCustomAttributesQuery {\n  sys_property_type_custom_attributes {\n    property_type_id\n    custom_attributes\n  }\n}\n"
  }
};
})();

(node as any).hash = "82a86561df00085ea031f18d9fbe1e6c";

export default node;
